import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import MediaQuery from 'react-responsive';
import styles from './styles';

const FooterLink = props => (
    <MediaQuery maxDeviceWidth={767}>
        {(matches) =>
            <React.Fragment>
                {(!matches || (!Boolean(props.hideOnMobile))) &&
                    <li className={props.classes.footerLi}>
                        {props.href &&
                            <a className={props.classes.anchor} href={props.href} target={props.target}>{props.text}</a>
                        }
                        {!props.href &&
                            <span>{props.text}</span>
                        }
                    </li>
                }
            </React.Fragment>
        }
    </MediaQuery>
);

FooterLink.propTypes = {
    hideOnMobile: PropTypes.bool,
    text: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.string
};

export default withStyles(styles)(FooterLink);